import { Heart, Users, Award, Globe } from 'lucide-react';

export const About = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary-600 to-primary-800 text-white py-20">
        <div className="container text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">About NINEEYE INFOTECH SOLUTION PRIVATE LIMITED</h1>
          <p className="text-xl md:text-2xl opacity-90 max-w-3xl mx-auto">
            Your premier destination for quality fashion and lifestyle products. 
            We bring you the latest trends with exceptional service.
          </p>
        </div>
      </div>

      {/* Mission Section */}
      <div className="section-padding bg-white">
        <div className="container">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">Our Mission</h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              At NINEEYE INFOTECH SOLUTION PRIVATE LIMITED, we believe that everyone deserves access to high-quality, 
              fashionable products at affordable prices. Our mission is to curate a 
              collection that combines style, comfort, and value, making premium fashion 
              accessible to all.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              We are committed to providing an exceptional shopping experience with 
              fast shipping, easy returns, and outstanding customer service. Every 
              product in our collection is carefully selected to meet our high standards 
              of quality and style.
            </p>
          </div>
        </div>
      </div>

      {/* Values Section */}
      <div className="section-padding bg-gray-50">
        <div className="container">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Values</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              These core values guide everything we do at NINEEYE INFOTECH SOLUTION PRIVATE LIMITED
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="h-8 w-8 text-primary-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Quality First</h3>
              <p className="text-gray-600">
                We never compromise on quality. Every product is carefully selected 
                and tested to ensure it meets our high standards.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="h-8 w-8 text-primary-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Customer Focus</h3>
              <p className="text-gray-600">
                Our customers are at the heart of everything we do. We listen, 
                learn, and continuously improve based on your feedback.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="h-8 w-8 text-primary-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Excellence</h3>
              <p className="text-gray-600">
                We strive for excellence in every aspect of our business, from 
                product selection to customer service and delivery.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Globe className="h-8 w-8 text-primary-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Sustainability</h3>
              <p className="text-gray-600">
                We are committed to sustainable practices and work with partners 
                who share our environmental values.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Story Section */}
      <div className="section-padding bg-white">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Our Story</h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                NINEEYE INFOTECH SOLUTION PRIVATE LIMITED was founded in 2025 with a simple vision: to make quality 
                fashion accessible to everyone. What started as a small online store 
                has grown into a trusted destination for thousands of customers.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                Our team of fashion experts carefully curates each product, ensuring 
                that our customers receive not just great value, but also the latest 
                trends and timeless classics.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Today, we're proud to serve customers across India with fast shipping, 
                easy returns, and exceptional customer service. We continue to grow 
                and evolve, always keeping our customers' needs at the forefront.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="section-padding bg-primary-600 text-white">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl md:text-5xl font-bold mb-2">10K+</div>
              <div className="text-lg opacity-90">Happy Customers</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold mb-2">500+</div>
              <div className="text-lg opacity-90">Products</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold mb-2">50+</div>
              <div className="text-lg opacity-90">Cities Served</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold mb-2">24/7</div>
              <div className="text-lg opacity-90">Customer Support</div>
            </div>
          </div>
        </div>
      </div>

      {/* Team Section */}
      
    </div>
  );
};
